export default {
  path: 'excavation-service/excavation-settings/district_offices',
  name: 'ExcavationSettingsDistrictOffices',
  meta: {
    title: 'road-maintenance/dropdown-types.road_administration',
    create_title: 'road-maintenance/excavation-dropdown-type.create_road_administration',
    edit_title: 'road-maintenance/excavation-dropdown-type.edit_road_administration',
    delete_title: 'road-maintenance/excavation-dropdown-type.delete_road_administration',
    confirm_delete: 'road-maintenance/excavation-dropdown-type.confirm_delete_road_administration',
    import_title: 'road-maintenance/excavation-dropdown-type.import_road_administration',
    name_label: 'road-maintenance/dropdown-types.road_administration',
    name: 'ROAD_ADMINISTRATION'
  },
  component: () => import(/* webpackChunkName: "road-maintenance" */ '../views/ExcavationSettingsIndex')
}
